// Color de muestra de un nombre de color del catálogo («Negro», «Azul claro»). El catálogo solo
// trae el nombre; un color desconocido cae en gris neutro y el nombre siempre se muestra aparte.

const BASE_COLORS: Record<string, string> = {
    negro: '#1f2937',
    grafito: '#374151',
    gris: '#9ca3af',
    plata: '#d1d5db',
    plateado: '#d1d5db',
    blanco: '#ffffff',
    crema: '#f5f0e1',
    beige: '#e7dcc8',
    azul: '#3b82f6',
    marino: '#1e3a8a',
    celeste: '#93c5fd',
    turquesa: '#2dd4bf',
    verde: '#22c55e',
    menta: '#a7f3d0',
    morado: '#8b5cf6',
    violeta: '#8b5cf6',
    lila: '#c4b5fd',
    lavanda: '#c4b5fd',
    rosa: '#f9a8d4',
    rojo: '#ef4444',
    naranja: '#f97316',
    amarillo: '#facc15',
    dorado: '#d4a373',
    oro: '#d4a373',
    cobre: '#b87333',
    cafe: '#8b5e3c',
    titanio: '#a8a29e',
};

const LIGHT_SHADES: Record<string, string> = {
    azul: '#93c5fd',
    verde: '#86efac',
    morado: '#c4b5fd',
    rosa: '#fbcfe8',
    gris: '#d1d5db',
};

const DARK_SHADES: Record<string, string> = {
    azul: '#1e40af',
    verde: '#166534',
    morado: '#5b21b6',
    gris: '#4b5563',
};

/** Muestra de un color sin nombre conocido. */
export const UNKNOWN_SWATCH = '#d4d4d8';

function fold(text: string): string {
    return text.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();
}

/** El CSS de la muestra; toma la primera palabra que reconoce y aplica «claro»/«oscuro». */
export function swatchColorOf(name: string): string {
    const words = fold(name).split(/\s+/);
    const base = words.find((word) => word in BASE_COLORS);
    if (base === undefined) return UNKNOWN_SWATCH;
    if (words.includes('claro')) return LIGHT_SHADES[base] ?? BASE_COLORS[base];
    if (words.includes('oscuro')) return DARK_SHADES[base] ?? BASE_COLORS[base];
    return BASE_COLORS[base];
}
